
import React, { Fragment, useState, useContext  } from 'react';

import LoginContext from '../../../../store/login-context';

import Ajax from '../../../../Handler/Ajax';
import classes from './MailOtp.module.scss';
import eye from '../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../assets/icons/outline_eye_bright-off.svg';
import timer from '../../../../assets/icons/timer.svg';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';
import Toast from '../../../Form/Toast';
import GovSpinner from '../../../Form/GovSpinner';
import alert from '../../../../assets/icons/alert-circle-red.svg';
import arrowRightBlue from '../../../../assets/icons/arrow-right-blue.svg';
import BackLink from '../../../General/Static/BackLink/BackLink';

declare function Translate(key: string): string;
declare var _loginMethodSmsOtpUrl: any;
declare var _loginType: any;
declare var _loginTypeSMSOTPSmartphoneEnrollment: any;

const MailOtp = props => {    
    const ctx = useContext(LoginContext);

    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [controlType,setControlType] = useState('password');
    const [serverMessage,setServerMessage] = useState('');    
    const [otpDirty,setOtpDirty] = useState(false);

    const onSubmitForm = (event) => {
        event.preventDefault();
    };
    
    const isOtpValid = () => {
        return /\d{6}/.test(otp);
    };

    const handleOtp = (e: React.ChangeEvent<HTMLInputElement>) => {
        const regex = /^[0-9]{0,6}$/;
        if (regex.test(e.target.value.toString()))
          setOtp(e.target.value);      
    };

    const handleEnter = (event) => {    
        if (event.charCode === 13) {      
          if(isOtpValid()){
            SecondStageLogin();
          }      
        }
    };

    const onOtpBlur = () => {
        if(otp.length>0 && !otpDirty){
          setOtpDirty(true);
        }
    };

    const otpValidationMessage = () => {
        return otp.length === 0
          ? Translate('N_General_Error_Mandatory_Field')
          : Translate('N_General_Error_PIN_too short');
      };

    const SecondStageLogin = () => {    
        setServerMessage('');
    
        if(ctx.devMode){
          let neededInfo = [
            'email',   
            'mobile',     
            'password',
            'prefferedContactMethods',
          ];
    
          props.Success(neededInfo);
          return;
        }
    
        if (otp.length !== 0) {      
          setLoading(true);
          
          Ajax.SecondLoginSMS(otp)
            .then((data: any) => {                              
              Ajax.onPKILoginEnd()
                .then((data: any) => {
                    if(data.neededInfo[0].trim().length === 0 && data.currentState === "updateDetailsDone"){
                        Ajax.onPKILoginEndPK()
                          .then((data: any) => {
                            setLoading(false);
                            props.Success(data.neededInfo);
                          })
                          .catch((error) => {
                            setLoading(false);
                            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
                          });   
                    }
                    else{
                    props.Success(data.neededInfo);
                    }  
                })
                .catch((error) => {
                  setLoading(false);
                  setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
                });
            })
            .catch((error) => {
              setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
              setLoading(false);                                         
            });      
        }
    };

    const onBackHandler = () => {          
        if (!ctx.devMode) {
            setLoading(true); 
            Ajax.ResetUserStatus()
                .then(() => {           
                    setLoading(false);        
                    window.location = _loginMethodSmsOtpUrl;
                })
                .catch(() => {   
                    setLoading(false); 
                    setServerMessage(Translate('N_General_Error_SYSTEM_ERROR'));           
                });
        }
        else{      
            window.location = _loginMethodSmsOtpUrl;
        }     
    };
    

    return(
        <Fragment>
            <GovSpinner show={loading} />
            <div className={classes.mail_otp_wrapper}>
            <form className='normal-form' onSubmit={onSubmitForm} >
                { _loginType !== _loginTypeSMSOTPSmartphoneEnrollment &&                   
                    <BackLink back={onBackHandler} loginType="" translate={Translate('N_Login_application_pop_up_3')}/> 
                }
                <div className='otp_heading'> 
                    <div className='title-large'>{Translate('N_Login_we_sent_OTP_by_email')}</div>
                    <div className={classes.description}>
                        <span className='text-space'>
                            {Translate('N_Login_enter_OTP_from_email')}                           
                        </span>                        
                        <span className={classes.mask_otp}>{props.maskMailDest}</span>
                    </div>          
                </div>
                <div className='mainFormZone mt-4'>                
                    <label htmlFor='mailOtp' className='my-1 d-flex align-items-center justify-content-between'>
                        <div>
                            {Translate('N_Login_reset_password_stage_2')}                                         
                        </div>
                        <div 
                            className='mx-2 d-flex align-items-center'
                            onClick={() =>
                            setControlType(
                                controlType === 'password'
                                ? 'text'
                                : 'password'
                            )
                            }
                        >
                            <img
                            src={controlType === 'password' ? eye : eyeOff}
                            width='22px'
                            height='18px'
                            
                            role='button'
                            tabIndex={0}
                            className={
                                otp
                                ? 'mx-1 password-view-show'
                                : 'mx-1 password-view-hide'
                            }
                            
                            />
                            <span 
                            className={
                                otp
                                ? 'password-view-show'
                                : 'password-view-hide'
                            }
                            >
                            {controlType === 'password' 
                                ? Translate('N_Login_Bio_ID_OTP_Show_OTP')
                                : Translate('N_Login_Bio_ID_OTP_Hide_OTP')
                            }
                            </span>                      
                        </div>
                    </label>
                    <input  
                        autoFocus   
                        aria-describedby= {`${Translate('N_General_SignUp_confirm_mobile_info_1')} ${props.maskMailDest} ${Translate('N_General_SignUp_confirm_mail_info_2')}`} 
                        id='mailOtp'
                        aria-required="true"
                        type= 'tel' 
                        placeholder="_ _ _ _ _ _"
                        value={otp}
                        onChange={handleOtp}
                        onKeyPress={handleEnter}
                        onBlur={onOtpBlur}
                        className={
                        `
                            form-control gov-black                                            
                            ${!isOtpValid() && otpDirty ? ' error-control' : ''} 
                            ${controlType === 'password' ? classes.password_mask : ''}
                        `                    
                        }
                    />                
                       
                    {otpDirty && !isOtpValid() && (
                        <div className='d-flex align-items-center'>
                        <img src={alert}  className='error-alert' />
                        &nbsp;
                        <span className='small error'>
                            {otpValidationMessage()}
                        </span>
                        </div>
                    )}

                    <div className='d-flex align-items-center mt-1'>
                        <img src={timer}  width='16px' height='19px' />
                        &nbsp;
                        <span className={classes.note}>
                        {Translate('N_General_otp_time_limit_1')}
                        </span>
                    </div>
                    
                    {serverMessage.length > 0 && (
                        <Toast message={serverMessage} />
                    )}

                    <div className={classes.height_space}></div>
                    <SubmitBtn
                        title={Translate('N_Login_password_login_button')}
                        id="loginMailOtpSubmit"
                        action={SecondStageLogin}
                        showIcon={true}
                        disabled={!isOtpValid()}
                    />                                                                    
                </div>
            </form>
            </div>
        </Fragment>
    );
}

export default MailOtp;